import Image from 'next/image';

import { Box, Flex, Text } from '@chakra-ui/react';

import { ExternalLink } from '~/components/external-link';
import { Glyph } from '~/components/glyph';

export function BottomSection() {
  return (
    <Box as='section'>
      <Flex alignItems='center' flexDirection={{ base: 'column', lg: 'row' }} gap='40px' justifyContent='space-between'>
        <Image
          alt='The New York Times logo'
          height={30}
          quality={100}
          src='/images/news-logos/the_new_york_times.svg'
          width={203}
        />
        <Image
          alt='The Economist logo'
          height={30}
          quality={100}
          src='/images/news-logos/the_economist.svg'
          width={98}
        />
        <Image
          alt='Handelsblatt logo'
          height={22}
          quality={100}
          src='/images/news-logos/handelsblatt.svg'
          width={145}
        />
        <Image alt='Tech Crunch logo' height={49} quality={100} src='/images/news-logos/tc.svg' width={70} />
        <Image alt='Bloomberg logo' height={27} quality={100} src='/images/news-logos/bloomberg.svg' width={132} />
        <Image
          alt='Financial Times logo'
          height={35}
          quality={100}
          src='/images/news-logos/financial_times.svg'
          width={118}
        />
      </Flex>

      <Box h='40px' />

      <Box
        alignItems={{ base: 'flex-start', lg: 'center' }}
        bg='white'
        borderRadius='lg'
        display='flex'
        flexDirection={{ base: 'column', lg: 'row' }}
        gap='8px'
        paddingX='40px'
        paddingY='16px'
        shadow='lg'
      >
        <Glyph height={48} name='telecom-one' width={48} />
        <Text size='label'>
          For specific media inquiries, get in touch with our press team:{' '}
          <ExternalLink href='mailto:media@udacity.com'>media@udacity.com</ExternalLink>
        </Text>
      </Box>
    </Box>
  );
}
